import { useState } from 'react';
import { API_CONFIG } from '../config/apiConfig';
import { apiClient } from '../utils/apiClient';

interface SupportedItem {
  itemNumber: string;
  mfgPartNumber: string;
  itemDescription: string;
}

interface ApiResponse {
  success: boolean;
  data?: any[];
  error?: string;
}

export const useSupportedItemList = () => {
  const [data, setData] = useState<SupportedItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSupportedItems = async (fromOrg: string) => {
    if (!fromOrg) return;

    setIsLoading(true);
    setError(null);

    try {
      const response = await apiClient.get<ApiResponse>(`${API_CONFIG.ENDPOINTS.GET_SUPP_ITEM_LIST}?p_from_org=${encodeURIComponent(fromOrg)}`);
      
      let responseData = response.data;
      if (response.data.data && typeof response.data.data === 'object' && 'statusCode' in response.data.data) {
        responseData = JSON.parse((response.data.data as any).body);
      }
      
      if (responseData.success && responseData.data) {
        const items = responseData.data.map((item: any) => ({
          itemNumber: item.itemNumber || item.ITEM_NUMBER || item.item_number || '',
          mfgPartNumber: item.mfgPartNumber || item.MFG_PART_NUMBER || item.mfg_part_number || '',
          itemDescription: item.itemDescription || item.ITEM_DESCRIPTION || item.item_description || ''
        }));
        setData(items);
      } else {
        throw new Error(responseData.error || 'Failed to fetch supported items');
      }
    } catch (err) {
      console.error('Error fetching supported items:', err);
      setError(err instanceof Error ? err.message : 'Unknown error');
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isLoading,
    error,
    fetchSupportedItems
  };
};